import Vue from 'vue'
import App from './App.vue'

import router from './views/router'
import store from './views/store'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko'
import 'element-ui/lib/theme-chalk/index.css';
import VueTableDynamic from 'vue-table-dynamic';
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./views/web/resource/table.css"
import * as VueGoogleMaps from "vue2-google-maps" // Import package

axios.defaults.withCredentials = true

Vue.use(BootstrapVue)
Vue.use(ElementUI, {locale});
Vue.use(VueTableDynamic);


Vue.config.productionTip = false
Vue.use(axios)
Vue.prototype.$http = axios
// Vue.prototype.$url = 'http://localhost:8080/alienServer'
// Vue.prototype.$url = 'http://mw.alienrfid.com'
// Vue.prototype.$url = 'http://localhost:8154'

Vue.prototype.$url = process.env.VUE_APP_API_SERVER
document.title = "MS";

Vue.use(VueGoogleMaps,
    // { load: { key: "AIzaSyAeAn_yYRf8--DmHjWYz7gZ9y3yCpRnEpM", libraries: "places", region: "KR"
    { load: { key: "AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg", libraries: "places", region: "KR"
 } });






new Vue({
  router,
  store,
  render: h => h(App),
    data: {
        product: { Image_url: 'https://makesolutions.kr/uploads/1.png' }
    }
}).$mount('#app')

